import 'babel-polyfill';
import 'zone.js/dist/zone';



// WEBPACK FOOTER //
// ./ng1/polyfills.ts